"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _grid = require("@rebass/grid");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _UnreachableCaseError = require("../../entities/UnreachableCaseError");
var _excluded = ["placeholder", "fadeInDuration", "blurAmount", "scaleAmount", "fallback", "sources", "loading", "width", "height", "alt", "title", "className", "addNoscript"];
/* eslint-disable jsx-a11y/alt-text */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var imageCache = {};
var addToImageCache = function addToImageCache(src) {
  if (typeof document === 'undefined') {
    return;
  }
  imageCache[src] = true;
};
var isImageCached = function isImageCached(src) {
  if (typeof document === 'undefined') {
    return false;
  }
  if (!src) {
    return false;
  }
  return imageCache[src] || false;
};
var generateNoscriptSource = function generateNoscriptSource(props) {
  var type = props.type ? "type=".concat(props.type) : '';
  var srcSet = props.srcSet ? "srcset=".concat(props.srcSet) : '';
  return "<source ".concat(type).concat(srcSet, "/>");
};
var generateNoscriptSources = function generateNoscriptSources() {
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  return sources.map(generateNoscriptSource).join("");
};
var noscriptImg = function noscriptImg(props) {
  var _props$sources;
  // Check if prop exists before adding each attribute to the string output below to prevent
  // HTML validation issues caused by empty values like width="" and height=""
  var src = props.fallback.src ? "src=\"".concat(props.fallback.src, "\" ") : "src=\"\" "; // required attribute
  var srcSet = props.fallback.srcSet ? "srcset=\"".concat(props.fallback.srcSet, "\" ") : "";
  var title = props.title ? "title=\"".concat(props.title, "\" ") : "";
  var alt = props.alt ? "alt=\"".concat(props.alt, "\" ") : "alt=\"\" "; // required attribute
  var width = props.width ? "width=\"".concat(props.width, "\" ") : "";
  var height = props.height ? "height=\"".concat(props.height, "\" ") : "";
  var loading = props.loading ? "loading=\"".concat(props.loading, "\" ") : "";
  var sources = generateNoscriptSources.apply(void 0, (0, _toConsumableArray2["default"])((_props$sources = props.sources) !== null && _props$sources !== void 0 ? _props$sources : []));
  return "<picture>".concat(sources, "<img ").concat(loading).concat(width).concat(height).concat(srcSet).concat(src).concat(alt).concat(title, "style=\"position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center\"/></picture>");
};

/**
 * There are basically three ways to use the `Img` component.
 *
 * 1. Default, where width and height are required and an image with static dimensions will be displayed
 * 2. `layout: fill` will fill its parent container
 * 3. `layout: ratio` will size the image according to the ratio that's given as a prop
 */
function Img(props) {
  var placeholder = props.placeholder,
    _props$fadeInDuration = props.fadeInDuration,
    fadeInDuration = _props$fadeInDuration === void 0 ? 500 : _props$fadeInDuration,
    _props$blurAmount = props.blurAmount,
    blurAmount = _props$blurAmount === void 0 ? '10px' : _props$blurAmount,
    _props$scaleAmount = props.scaleAmount,
    scaleAmount = _props$scaleAmount === void 0 ? 1.2 : _props$scaleAmount,
    fallback = props.fallback,
    sources = props.sources,
    loading = props.loading,
    _props$width = props.width,
    width = _props$width === void 0 ? '100%' : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? '100%' : _props$height,
    alt = props.alt,
    title = props.title,
    className = props.className,
    _props$addNoscript = props.addNoscript,
    addNoscript = _props$addNoscript === void 0 ? false : _props$addNoscript,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var showNoscript = addNoscript || loading === 'eager';
  var ref = (0, _react.useRef)(null);
  var inCache = isImageCached(fallback.src);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  var onLoad = (0, _react.useCallback)(function () {
    setLoaded(true);
    if (fallback.src) {
      addToImageCache(fallback.src);
    }
  }, [fallback.src]);
  (0, _react.useEffect)(function () {
    var _ref$current;
    // if the img has already been downloaded onLoad won't trigger so we do it manually
    if ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.complete) {
      onLoad();
    }
  }, [onLoad]);
  var srcRef = (0, _react.useRef)(fallback.src);
  (0, _react.useEffect)(function () {
    var resetImgState = function resetImgState() {
      setLoaded(false);
    };
    if (srcRef.current !== fallback.src) {
      resetImgState();
    }
    srcRef.current = fallback.src;
  }, [fallback.src]);
  return /*#__PURE__*/_react["default"].createElement(Container, {
    key: fallback.src,
    width: width,
    height: height,
    className: className,
    ratio: rest.layout === 'ratio' ? rest.ratio : 0,
    layout: rest.layout
  }, /*#__PURE__*/_react["default"].createElement(Placeholder, {
    title: title,
    alt: alt,
    width: width,
    height: height,
    blurAmount: blurAmount,
    scaleAmount: scaleAmount,
    src: placeholder,
    loading: loading,
    "aria-hidden": true,
    style: {
      opacity: loaded ? 0 : 1,
      transition: "opacity 0ms",
      transitionDelay: inCache ? '0ms' : "".concat(fadeInDuration, "ms")
    }
  }), /*#__PURE__*/_react["default"].createElement(Picture, null, sources === null || sources === void 0 ? void 0 : sources.map(function (source, i) {
    return /*#__PURE__*/_react["default"].createElement("source", Object.assign({
      key: i
    }, source));
  }), /*#__PURE__*/_react["default"].createElement("img", Object.assign({
    title: title,
    alt: alt,
    ref: ref,
    width: width,
    height: height,
    loading: loading,
    onLoad: onLoad
  }, fallback, {
    style: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, fallback.style), {}, {
      opacity: loaded ? 1 : 0,
      transition: 'opacity ease',
      transitionDuration: inCache ? '0ms' : "".concat(fadeInDuration, "ms")
    })
  })), showNoscript && /*#__PURE__*/_react["default"].createElement("noscript", {
    dangerouslySetInnerHTML: {
      __html: noscriptImg(props)
    }
  })));
}
var _default = exports["default"] = Img;
var Placeholder = _styledComponents["default"].img.withConfig({
  displayName: "Img__Placeholder",
  componentId: "sc-1yejx7t-0"
})(["filter:blur(", ");transform:scale(", ");object-fit:cover;pointer-events:none;background:", ";"], function (_ref) {
  var blurAmount = _ref.blurAmount;
  return blurAmount;
}, function (_ref2) {
  var scaleAmount = _ref2.scaleAmount;
  return scaleAmount;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.neutral['10'];
});
var parseDimension = function parseDimension(amount) {
  return typeof amount === 'number' ? "".concat(amount, "px") : amount;
};
var Container = (0, _styledComponents["default"])(_grid.Box).withConfig({
  displayName: "Img__Container",
  componentId: "sc-1yejx7t-1"
})(["width:", ";height:", ";overflow:hidden;", " img{position:absolute;left:0;top:0;right:0;bottom:0;width:100%;height:100%;object-fit:cover;object-position:center;}"], function (_ref4) {
  var width = _ref4.width;
  return parseDimension(width);
}, function (_ref5) {
  var height = _ref5.height;
  return parseDimension(height);
}, function (_ref6) {
  var layout = _ref6.layout,
    _ref6$ratio = _ref6.ratio,
    ratio = _ref6$ratio === void 0 ? 0 : _ref6$ratio;
  if (!layout) {
    return undefined;
  }
  switch (layout) {
    case 'fill':
      return (0, _styledComponents.css)(["position:absolute;left:0;top:0;right:0;bottom:0;"]);
    case 'ratio':
      return (0, _styledComponents.css)(["position:relative;&:before{display:block;content:'';width:100%;padding-top:", "%;}"], Math.round(ratio * 100));
    default:
      throw new _UnreachableCaseError.UnreachableCaseError(layout);
  }
});
var Picture = _styledComponents["default"].picture.withConfig({
  displayName: "Img__Picture",
  componentId: "sc-1yejx7t-2"
})([""]);
//# sourceMappingURL=Img.js.map